import React, { useMemo } from 'react';
import { useAuth } from '../../../../../container/authContext';
import { usePermission } from '../../../../../container/permissionContext';
import { STATIC_ROUTES } from '../../../../../constants/routes';
import PageTabs from '../../../../../components/other/page-tabs';
import { isMobile } from 'react-device-detect';
import './styles.scss';

const Header = () => {
  const { user = {} } = useAuth();
  const { isSuperAdmin, isCompanySystemAdministrator, hasPermissionByCodeName } = usePermission();

  const facilityId = new URLSearchParams(window.location.search).get('facility_id');

  const withFacility = (url) => {
    if (!facilityId) return url;

    const u = new URL(url, window.location.origin);
    u.searchParams.set('facility_id', facilityId);

    return u.pathname + u.search;
  };

  const tabs = useMemo(() => {
    const tabsList = [];

    if (hasPermissionByCodeName('scheduling_management') || hasPermissionByCodeName('scheduling_viewing')) {
      tabsList.push({
        url: withFacility(STATIC_ROUTES.SCHEDULING),
        label: 'Scheduling',
      });
    }

    if (hasPermissionByCodeName('scheduling_management')) {
      tabsList.push({
        url: withFacility(STATIC_ROUTES.MASTER_SCHEDULE),
        label: 'Master schedule',
      });
    }

    if (
      !isSuperAdmin() &&
      !isCompanySystemAdministrator() &&
      (hasPermissionByCodeName('shift_pickup_for_nurses') || hasPermissionByCodeName('shift_pickup_for_cnas'))
    ) {
      tabsList.push({
        url: STATIC_ROUTES.PICKUP_SHIFT,
        label: 'Pickup Shift',
      });
    }

    return tabsList;
  }, [user, isMobile, facilityId]);

  return <PageTabs tabs={tabs} />;
};

export default Header;
